// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1U3C1","calendarButtons":"ClockData_calendarButtons__z9XlW"};